export var GlobalFeaturesEnum;
(function (GlobalFeaturesEnum) {
    GlobalFeaturesEnum["extensionsForProAndClinics"] = "extensionsForProAndClinics";
})(GlobalFeaturesEnum || (GlobalFeaturesEnum = {}));
